import { Phone, Globe, MapPin, Clock, Download, Share2, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { usePageMeta } from "@/seo";
import { trackCall, trackText } from "@/analytics";

const PHOTO = "/dr-greenspan-new.png";

// Base64 encoded photo for VCF embedding
const VCF_PHOTO = "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";

const vCardData = `BEGIN:VCARD
VERSION:3.0
N:Greenspan;Kevin;;Dr.;DC
FN:Dr. Kevin Greenspan, DC
ORG:Dr. Kevin Greenspan, DC - Chiropractic
TITLE:Doctor of Chiropractic
TEL;TYPE=WORK,VOICE:(828) 691-3551
ADR;TYPE=WORK:;;4573 US 221 N;Marion;NC;28752;US
URL:https://kevingreenspan.com
PHOTO;ENCODING=b;TYPE=JPEG:${VCF_PHOTO}
NOTE:Applied Kinesiology | Extremity Adjustments | Full Spine Care\\nTue & Thu: 10AM-Noon, 3-6PM | By appointment only\\nText for appointments
END:VCARD`;

function downloadVCard() {
  const blob = new Blob([vCardData], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Dr-Kevin-Greenspan-DC.vcf";
  a.click();
  URL.revokeObjectURL(url);
}

async function shareCard() {
  if (navigator.share) {
    try {
      await navigator.share({
        title: "Dr. Kevin Greenspan, DC",
        text: "Chiropractor in Marion, NC — Applied Kinesiology & Extremity Adjustments",
        url: "https://kevingreenspan.com/card",
      });
    } catch {}
  } else {
    navigator.clipboard.writeText("https://kevingreenspan.com/card");
    toast.success("Link copied to clipboard!");
  }
}

export default function BusinessCard() {
  usePageMeta("/card");
  return (
    <div className="min-h-screen bg-[#F7F5F0] flex items-center justify-center p-6" data-testid="business-card-page">
      <div className="w-full max-w-md">
        {/* Card */}
        <div className="bg-white rounded-3xl border border-[#E4DCCF] overflow-hidden shadow-lg">
          {/* Header */}
          <div className="bg-[#3A4F41] px-8 pt-10 pb-16 text-center relative">
            <p className="font-body text-xs tracking-[0.2em] uppercase text-[#C87B5D] mb-2">Chiropractic Care</p>
            <h1 className="font-heading text-3xl font-medium text-white tracking-tight">Dr. Kevin Greenspan</h1>
            <p className="font-body text-sm text-white/70 mt-1">Doctor of Chiropractic</p>
          </div>

          {/* Photo */}
          <div className="flex justify-center -mt-12 relative z-10">
            <div className="w-24 h-24 rounded-full border-4 border-white overflow-hidden shadow-md">
              <img src={PHOTO} alt="Dr. Kevin Greenspan" className="w-full h-full object-cover object-top" />
            </div>
          </div>

          {/* Info */}
          <div className="px-8 pt-4 pb-8 space-y-5">
            <p className="text-center font-body text-sm text-[#5C6A61]">
              Applied Kinesiology &bull; Extremity Adjustments &bull; Full Spine Care
            </p>

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-3">
                <a href="tel:+18286913551" onClick={trackCall("card")} className="flex items-center gap-3 p-3 rounded-2xl bg-[#F7F5F0] hover:bg-[#E4DCCF]/50 transition-colors" data-testid="card-phone">
                  <div className="w-10 h-10 rounded-full bg-[#C87B5D]/10 flex items-center justify-center flex-shrink-0">
                    <Phone size={16} className="text-[#C87B5D]" />
                  </div>
                  <div>
                    <p className="font-body text-sm font-medium text-[#1A221E]">Call</p>
                    <p className="font-body text-xs text-[#5C6A61]">(828) 691-3551</p>
                  </div>
                </a>
                <a href="sms:+18286913551" onClick={trackText("card")} className="flex items-center gap-3 p-3 rounded-2xl bg-[#F7F5F0] hover:bg-[#E4DCCF]/50 transition-colors" data-testid="card-text">
                  <div className="w-10 h-10 rounded-full bg-[#C87B5D]/10 flex items-center justify-center flex-shrink-0">
                    <MessageSquare size={16} className="text-[#C87B5D]" />
                  </div>
                  <div>
                    <p className="font-body text-sm font-medium text-[#1A221E]">Text</p>
                    <p className="font-body text-xs text-[#5C6A61]">(828) 691-3551</p>
                  </div>
                </a>
              </div>

              <a href="https://kevingreenspan.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-3 rounded-2xl bg-[#F7F5F0] hover:bg-[#E4DCCF]/50 transition-colors" data-testid="card-website">
                <div className="w-10 h-10 rounded-full bg-[#3A4F41]/10 flex items-center justify-center flex-shrink-0">
                  <Globe size={16} className="text-[#3A4F41]" />
                </div>
                <div>
                  <p className="font-body text-sm font-medium text-[#1A221E]">kevingreenspan.com</p>
                  <p className="font-body text-xs text-[#5C6A61]">Visit website</p>
                </div>
              </a>

              <div className="flex items-center gap-4 p-3 rounded-2xl bg-[#F7F5F0]">
                <div className="w-10 h-10 rounded-full bg-[#3A4F41]/10 flex items-center justify-center flex-shrink-0">
                  <MapPin size={16} className="text-[#3A4F41]" />
                </div>
                <div>
                  <p className="font-body text-sm font-medium text-[#1A221E]">Earth Heart</p>
                  <p className="font-body text-xs text-[#5C6A61]">4573 US 221 N, Marion, NC 28752</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-3 rounded-2xl bg-[#F7F5F0]">
                <div className="w-10 h-10 rounded-full bg-[#C87B5D]/10 flex items-center justify-center flex-shrink-0">
                  <Clock size={16} className="text-[#C87B5D]" />
                </div>
                <div>
                  <p className="font-body text-sm font-medium text-[#1A221E]">Tue & Thu</p>
                  <p className="font-body text-xs text-[#5C6A61]">10AM–Noon & 3–6PM &bull; By appointment only</p>
                </div>
              </div>
            </div>

            {/* Action buttons */}
            <div className="flex gap-3 pt-2">
              <Button
                data-testid="card-save-contact"
                onClick={downloadVCard}
                className="flex-1 rounded-full bg-[#C87B5D] hover:bg-[#b56a4e] text-white font-body text-sm h-11"
              >
                <Download size={16} className="mr-2" />
                Save Contact
              </Button>
              <Button
                data-testid="card-share"
                onClick={shareCard}
                variant="outline"
                className="rounded-full border-[#E4DCCF] text-[#3A4F41] font-body text-sm h-11 px-4 hover:bg-[#F7F5F0]"
              >
                <Share2 size={16} />
              </Button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center font-body text-xs text-[#5C6A61] mt-6">
          See our Google reviews
        </p>
        <a
          href="https://greenspanbusinessgrowthsystems.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 flex flex-col items-center gap-2 opacity-50 hover:opacity-80 transition-opacity"
          data-testid="card-created-by"
        >
          <span className="font-body text-[9px] tracking-[0.3em] uppercase text-[#5C6A61]/50">Created By</span>
          <img src="/gbgs-logo-clean.png" alt="Greenspan Business Growth Systems" className="w-[140px]" />
          <span className="font-body text-[11px] text-[#5C6A61]/60 tracking-wide">greenspanbusinessgrowthsystems.com</span>
        </a>
      </div>
    </div>
  );
}
